import API from '../../../../../services/api';

export const FINANZAS_API = {
    get: async () => {
        return await API.get('/finanzas').then(res => res.data);
    },
    getTransfersToApprove: async (type) => {
        return await API.get('/finanzas/transferencias?type=' + type).then(res => res.data);
    },
    getPendingOrders: async (type) => {
        return await API.get('/finanzas/pedidos?type='+ type).then(res => res.data);
    },
    getReceipt: async (comprobante, type) => {
        return await API.get('/finanzas/comprobante/' + comprobante + '?type=' + type).then(res => res.data);
    },
    approvePartOrder: async (ventaId, piezaId, type) => {
        return await API.get('/finanzas/' + ventaId + '/confirmacion/' + piezaId + '?type=' + type).then(res => res.data);
    }
}